export default __webpack_public_path__ + "static/media/5.109e7379.png";